import React from 'react';
import { SparkBoardContext } from 'contexts/SparkBoardContext';
import type { SparkBoardContextValue } from 'contexts/SparkBoardContext';
import { useNodesState } from 'reactflow';
import type { Node } from 'reactflow';

// Define the props
interface SparkBoardContextProps {
  children: React.ReactNode;
}

// Create a Provider component
const SparkBoardContextProvider = ({ children }: SparkBoardContextProps) => {
  const [nodes, setNodes, onNodesChange] = useNodesState<Node>([]);

  // Provide the context value to the children
  const contextValue: SparkBoardContextValue = {
    nodes,
    setNodes,
    onNodesChange,
  };

  return (
    <SparkBoardContext.Provider value={contextValue}>
      {children}
    </SparkBoardContext.Provider>
  );
};

export default SparkBoardContextProvider;
